import { observer } from 'mobx-react-lite';
import React, { useCallback, useMemo } from 'react';
import PopupSimpleContent from 'routes/Dashboard/Popup/PopupSimpleContent/PopupSimpleContent';
import PopupWrapper from 'routes/Dashboard/Popup/PopupWrapper/PopupWrapper';
import { useStores } from 'stores/useStores';

const ErrorModal = observer(() => {
  const { errorStore } = useStores();

  const currentError = useMemo(() => errorStore.errors[0], [errorStore.errors]);

  const onClose = useCallback(() => {
    errorStore.remove(currentError);
  }, [currentError, errorStore]);

  if (!currentError) {
    return null;
  }

  return (
    <PopupWrapper borderColor={currentError.topBorderColor}>
      <PopupSimpleContent popup={currentError} onClose={onClose} />
    </PopupWrapper>
  );
});

export default ErrorModal;
